<template>
  <div v-if="isRefurbProcessEnabled && !isSmartphone && isProductRefurbished">
    <USRefurbProcessReassuranceItems
      v-if="selectedOffer"
      :shipping="selectedOffer.shipping"
    />
    <USRefurbProcessCard />
    <USRefurbProcessDrawer />
  </div>

  <div v-else>
    <ContainerReassuranceItems />
    <ContainerVerifiedRefurbishedCarousel />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import ContainerReassuranceItems from '~/scopes/product-core/components/containers/ContainerReassuranceItems/ContainerReassuranceItems.vue'
import ContainerVerifiedRefurbishedCarousel from '~/scopes/product-core/components/containers/ContainerVerifiedRefurbishedCarousel/ContainerVerifiedRefurbishedCarousel.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import USRefurbProcessCard from '~/scopes/product-core/pages/ProductDetailPage/us/components/presentationals/USRefurbProcessCard/USRefurbProcessCard.vue'
import USRefurbProcessDrawer from '~/scopes/product-core/pages/ProductDetailPage/us/components/presentationals/USRefurbProcessDrawer/USRefurbProcessDrawer.vue'
import USRefurbProcessReassuranceItems from '~/scopes/product-core/pages/ProductDetailPage/us/components/presentationals/USRefurbProcessReassuranceItems/USRefurbProcessReassuranceItems.vue'

const { selectedOffer } = useFetchPickers()
const { data: productResponse } = useFetchProduct()

const isSmartphone = computed(() => {
  return productResponse.value?.tracking.categoryId === '2'
})

const isProductRefurbished = computed(() => {
  return productResponse.value?.type === 'Refurbished'
})

const experiments = useExperiments()
const isRefurbProcessEnabled =
  experiments['experiment.refurbProcess'] === 'withRefurbProcess'
</script>
